import { useState } from "react";
import { Icon } from "@shopify/polaris";
import { ExitIcon, PersonIcon } from "@shopify/polaris-icons";
import ShopLogo from "./ShopLogo";
import PortalPopover, { PortalActionList } from "./PortalPopover";
import getShopUrl from "../../utils/getShopUrl";
import "../../assets/scss/portal.scss";

// Guest pages: centered shop logo. Logged-in pages: logo left, user + logout menu right.
const PortalHeader = ({ shop, user, onLogout }) => {
    const [menuOpen, setMenuOpen] = useState(false);

    const displayName = user?.name || user?.email || "";
    const storeUrl = getShopUrl(shop);

    const userInfo = user && (
        <span className="portal-header__user">
            <span className="portal-header__avatar">
                {displayName.charAt(0)}
            </span>
            <span className="portal-header__user-text">
                {user.name && (
                    <p className="portal-header__user-name">{user.name}</p>
                )}
                {user.email && (
                    <p className="portal-header__user-email">{user.email}</p>
                )}
            </span>
        </span>
    );

    return (
        <header
            className={`portal-header ${user ? "portal-header--with-user" : ""}`}
        >
            <div className="portal-header__wrap">
                {/* Logo / name opens the Shopify store */}
                {storeUrl ? (
                    <a
                        href={storeUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="portal-header__store-link"
                    >
                        <ShopLogo shop={shop} />
                    </a>
                ) : (
                    <ShopLogo shop={shop} />
                )}
                {user && (
                    <PortalPopover
                        active={menuOpen}
                        onClose={() => setMenuOpen(false)}
                        alignment="right"
                        activator={
                            <button
                                className="portal-header__user-btn"
                                aria-label="Account menu"
                                aria-haspopup="menu"
                                aria-expanded={menuOpen}
                                onClick={() => setMenuOpen((open) => !open)}
                            >
                                {userInfo}
                                {/* Mobile: icon only; the info moves into the menu */}
                                <span className="portal-header__user-icon">
                                    <Icon source={PersonIcon} />
                                </span>
                            </button>
                        }
                    >
                        <div className="portal-header__menu-user">
                            {userInfo}
                        </div>
                        <PortalActionList
                            items={[
                                {
                                    content: "Log out",
                                    prefix: <Icon source={ExitIcon} />,
                                    onAction: () => {
                                        setMenuOpen(false);
                                        onLogout();
                                    },
                                },
                            ]}
                        />
                    </PortalPopover>
                )}
            </div>
        </header>
    );
};

export default PortalHeader;
